import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Removed ErrorBoundary import
import { monitoring } from './services/monitoring';
import { isProdEnv } from './services/env';

// Import Tailwind CSS Dynamic (if bundled)
import './styles/tailwind.css';

/**
 * GSC INDUSTRIAL BOOTSTRAP - V102.5
 */

// INITIALIZE INDUSTRIAL MONITORING
try {
  monitoring.init();
} catch (e) {
  console.warn("Monitoring init failed", e);
}

// root mounting
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    {/* Removed ErrorBoundary component */}
    <App />
  </React.StrictMode>
);

// Immediately hide the static loader if it exists
const hideLoader = () => {
  const initialLoader = document.getElementById('initial-loader');
  if (initialLoader) {
    initialLoader.style.opacity = '0';
    setTimeout(() => initialLoader.remove(), 500);
  }
};

// Check for ready state or window load
if (document.readyState === 'complete') {
  hideLoader();
} else {
  window.addEventListener('load', hideLoader);
}